import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getWinner } from '@/lib/api';
import { formatGBP, formatDateLong } from '@/lib/format';

const WinnerStoryPage = () => {
  const { id } = useParams();
  const [w, setW] = useState(null);
  useEffect(() => { getWinner(id).then(setW).catch(() => {}); }, [id]);
  if (!w) return <div className="container-pd py-16 font-mono text-muted-sage">Loading…</div>;
  return (
    <div className="container-pd py-16" data-testid="winner-story-page">
      <Link to="/winners" className="text-sm text-muted-sage hover:text-[color:var(--pd-accent-yellow)]">← All winners</Link>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-6">
        <img src={w.photo_url} alt={w.winner_name_first} className="w-full aspect-square object-cover rounded-2xl border border-pd" />
        <div>
          <div className="font-mono text-[10px] text-[color:var(--pd-gold)] uppercase tracking-widest">Winner • {formatDateLong(w.drawn_at)}</div>
          <h1 className="font-display text-5xl md:text-6xl leading-none mt-3">{w.prize}</h1>
          <div className="mt-3 font-italic-serif text-2xl">{w.winner_name_first}, {w.location}</div>
          <div className="mt-2 text-[color:var(--pd-gold)]">Won with a {formatGBP(w.ticket_price_gbp)} ticket</div>
          <p className="mt-6 font-italic-serif text-xl leading-relaxed">“{w.quote}”</p>
          <div className="mt-8 font-mono text-xs text-muted-sage">Winning ticket: <span className="text-[color:var(--pd-text)]">{w.ticket_number}</span></div>
        </div>
      </div>
    </div>
  );
};

export default WinnerStoryPage;
